import config from "appConfig";
import { LayoutComponent } from "packages/lesson/dist/@types";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/03/26/principle/noise-map-no-treatment.svg`,
          styles: {
            maxWidth: "80%",
          },
        },
      },
    },
  },
];

export default components;
